/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import ClaimSharedTable from './ClaimSharedTable'
import { Claim } from '@dataTypes/claimFeature.types'
import { formatDate } from '@utils/date.utils'

type ClaimExpandedContentProps = {
  claim: Claim
}

const ClaimExpandedContent: React.FC<ClaimExpandedContentProps> = ({
  claim,
}) => {
  const columns = [
    {
      key: 'groupId',
      label: 'Group no.',
      formatter: (_: any, row: Claim) => row.groupId || '-',
      style: { width: '160px' },
    },
    {
      key: 'updatedAt',
      label: 'Last updated',
      formatter: (_: any, row: Claim) => formatDate(row.updatedAt),
      style: { width: '160px' },
    },
    { key: 'providerName', label: 'Provider', style: { width: '180px' } },
    {
      key: 'insurancePayments',
      label: 'Insurance payment',
      formatter: (_: any, row: Claim) =>
        row.insurancePayments && row.insurancePayments.length > 0
          ? 'Yes'
          : 'No',
      style: { width: 'auto' },
    },
    {
      key: 'numProcedures',
      label: 'No. of procedures',
      formatter: (_: any, row: Claim) => row.procedures.length,
      style: { width: '160px' },
    },
    {
      key: 'estimatedInsurance',
      label: 'Estimated ins.',
      formatter: (_: any, row: Claim) => {
        const totalEstimatedInsurancePay = (
          row.procedures?.reduce(
            (sum, procedure) =>
              sum + (Number(procedure.estimated_insurance_pay) || 0),
            0,
          ) || 0
        ).toFixed(2)
        return totalEstimatedInsurancePay
      },
      style: { width: '160px' },
    },
    { key: 'blank', label: '', style: { width: '200px' } },
    { key: 'blank', label: '', style: { width: '160px' } },
  ]

  return (
    <div className="expanded-content-wrapper">
      <ClaimSharedTable
        columns={columns}
        data={[claim]}
        className="expanded-table"
        useDynamicPageScroll={false}
        enableTableScroll={false}
      />
    </div>
  )
}

export default React.memo(ClaimExpandedContent)
